export default __webpack_public_path__ + "static/media/sd-donation.2d1ca055.png";